import styled from '@emotion/styled';
import { BendLogoSvg } from 'components/_global/header/GlobalHeader';
import { Text } from 'components/_temp_ui_common/theme/Text';
import { spacing } from 'components/core/theme';

import {
  LeadHeaderUrl,
  LeadProgram,
  LeadProgramColor,
  LeadProgramLogoColors,
  LeadProgramName,
} from '../constants';

export const Logo = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  max-height: ${spacing.xs};
  margin-top: ${spacing.xs};
  margin-bottom: ${spacing.xs};
  justify-content: center;
`;

export const LogoImg = styled.div`
  height: 10px;
  max-height: ${spacing.xs};
  max-width: ${spacing.l};
  min-width: 110px;
  flex-direction: column;
  align-itens: center;

  @media (max-width: 768px) {
    min-width: 92px;
  }
`;

const Header = ({ program }: { program: LeadProgram }) => {
  const url = LeadHeaderUrl[program];
  return (
    <div className="flex flex-col lg:my-8 my-4 uppercase items-center justify-center">
      <a href={url}>
        <Logo>
          <LogoImg>
            <BendLogoSvg {...LeadProgramLogoColors[program]} />
          </LogoImg>
        </Logo>
      </a>
      <div>
        <Text
          variant="body-6"
          bold
          className={'mt-4 !tracking-widest w-full'}
          style={{
            color: LeadProgramColor[program],
          }}
        >
          {LeadProgramName[program]}
        </Text>
      </div>
    </div>
  );
};
export default Header;
